import React, { AriaRole, useEffect, useState } from 'react';

export const IconSizes = {
  small: 'size-16',
  medium: 'size-24',
  large: 'size-32',
} as const;

export interface IconProps extends React.HTMLAttributes<HTMLElement> {
  className?: string;
  icon: React.ReactElement<React.SVGProps<SVGElement>>;
  size?: keyof typeof IconSizes;
  as?: React.ElementType;
  ariaLabel?: string;
  role?: AriaRole;
  hidden?: boolean;
}

export const Icon = ({ size, icon, as = 'span', ariaLabel, role, hidden, className = '', ...props }: IconProps) => {
  const [ariaHidden, setAriaHidden] = useState<string>('false');

  useEffect(() => {
    setAriaHidden(hidden ? 'true' : 'false');
  }, [hidden]);

  const ariaTags = {
    'aria-label': ariaLabel,
    'aria-hidden': ariaHidden
  };

  const svgWithProps = React.cloneElement(icon, {
    'aria-label': ariaLabel,
    'aria-hidden': ariaHidden,
    role: role,
    className: `w-full h-full box-border ${icon?.props?.className ?? ''}`,
    ...icon.props,
  });

  const Icon: React.ElementType = as;

  return (
    <Icon
      className={`inline-block box-content shrink-0 aspect-square ${size ? IconSizes[size] : ''} ${className}`} {...ariaTags}
      {...props}>
      {svgWithProps}
    </Icon>
  );
};
